import React, { useState } from 'react';
import Navbar from './Navbar';
import '../App.css';
import './AssessmentContent.css';
import Container from '@material-ui/core/Container';
import PlatformsSAP from '../MyComponents/Data/SystemVariable.json'


function AssessmentContent() {
    var assessmentURL=PlatformsSAP.filter((p)=>p["Key"]==="AssessmentUrl")[0]["Value"];
    return (
        <>
            <div className="tech-container main-container" id="assessment-box">
                <title>Job Readiness - Assessment Plan</title>
                <h1 className="sr-only" tabIndex={0}>Job Readiness - Assessment Plan</h1>
                <img src="/images/assessment-planner-banner.jpg" className="banner-img" alt=''  />
                <Navbar/> 
                <h2 id='main'><span>Assessment Planner</span> Overview</h2>
                <p>Assessment schedule for the entire course is published for all ASEs in the first week of their
                     JOB READINESS program. The assessment schedule provides the complete plan
                      (type of assessment, date, time, duration etc.) for all the assessments applicable to a cohort as a whole.
                       However, ASEs that complete their learning ahead of the cohort and are therefore comfortable with
                        taking an early assessment (MCQs), can reschedule assessment slot prior to that of their planned assessment dates. 
                        ASEs can login to the assessment planner portal (follow the given link to navigate), 
                        select the assessment they wish to attempt (MCQs), choose from available date/time slots 
                        as per their convenience and submit their nominations. Remember, faster completion of 
                        all JOB READINESS assessments means faster progression to SPECIALIZATION program!</p>
                <a href={assessmentURL} target="_blank" className="advance-btn">Re-schedule Assessment</a>
            </div>
        </>
    )
}

export default AssessmentContent;

